import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SkuInfo from '../components/SkuInfo';
import { useLocation } from 'react-router-dom';
import SkuMapping from '../components/SkuMapping';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function Sku() {
    const query = useQuery();
    const domain = query.get('domain');
    const sku = query.get('sku');

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
          SKU Details
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Detailed product specifications, vendor pricing, and SKU cross-mapping
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
        <SkuInfo domain={domain} skuCode={sku} />
        <SkuMapping domain={domain} skuCode={sku} />
      </Box>
    </Box>
  );
}
